import { createBrowserRouter } from "react-router-dom";
import App from "../App";
// import MainLayout from "../layout/MainLayout"; import {
// TimeDatePickerCalendar,AllBadges,AllButtons,AllDifferentInputType,AllDropDown
// , AllInputs,AllProgressBars,AllTypographys,AllUploadType,AllToasts } from
// "../pages";
import {
    MainAdminLogs,

    Login,
    Home,

    MainAdminUsers,
    MainAdminCategory,
    Chat,
    ChatMain, ChatDeepSeek, ChatRag, ChatSessions, ChatCreateImage,
    RagSystems, MainAdminAccessUsers, MainAdminDatasets, MainAdminWordCloud, MainAdminFaces, FaceRecognize,MainAdminFacesNames,
    MainAdminQuestions,MainAdminExams, MainAdminUserQuestions,MainAdminExamQuestions,MainAdminExamUsers,
    UserExam,MainAdminUsersExam

} from "../components";

import LayoutMainAdmin from "../layout/LayoutMainAdmin";
import TripLogin from "../pages/Trip/TripLogin";
import TripQuestions from "../pages/Trip/TripQuestinons";
import TripChat from "../pages/Trip/TripChat";
import TripFirstStep from "../pages/Trip/TripFirstStep";
import TripVoice from "../pages/Trip/TripVoice";
import TripForm from "../pages/Trip/TripForm";
import LoginCallback from "../pages/LoginCallback";

export const router = createBrowserRouter([


    // {
    //     path: "/",
    //     element: <NewUILayout />,
    //     errorElement: (
    //         <h3 className="text-center">Nothing !</h3>
    //     ),
    //     children: [
    //         {
    //             path: '/',
    //             element: <HomePage />
    //         }
    //         , {
    //             path: '/news/:cat/:id',  
    //             element: <SingleNews />
    //         }

    //         ,{
    //             path: '/contact-us',
    //             element: <ContactUs />
    //         }, {
    //             path: '/archive/:id',
    //             element: <Archive />
    //         },
    //         {
    //             path: '/archiveAllNews/:id',
    //             element: <ArchiveAllNews />
    //         },
    //         {
    //             path: '/Tag/:id',
    //             element: <Tag />
    //         },

    //         {
    //             path: '/about-us',
    //             element: <AboutUs />
    //         }
    //     ]
    // },
    {
        path: "/mainAdmin",
        element: <LayoutMainAdmin />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        ),
        children: [
            {
                path: '/mainAdmin/logs',
                element: <MainAdminLogs />
            },
            {
                path: '/mainAdmin/users',
                element: <MainAdminUsers />
            },
            {
                path: '/mainAdmin/categories',
                element: <MainAdminCategory />
            },

            {
                path: '/mainAdmin/ragSystems',
                element: <RagSystems />
            },


            {
                path: '/mainAdmin/aceessUsers',
                element: <MainAdminAccessUsers />
            },
            {
                path: '/mainAdmin/chatSessions',
                element: <ChatSessions />
            },
            {
                path: '/mainAdmin/datasets',
                element: <MainAdminDatasets />
            },
            {
                path: '/mainAdmin/wordCloud',
                element: <MainAdminWordCloud />
            },

            {
                path: '/mainAdmin/knowlegefaceRecognize',
                element: <MainAdminFaces />
            },
            {
                path: '/mainAdmin/knowlegefaceRecognizeName',
                element: <MainAdminFacesNames />
            },
            {
                path: '/mainAdmin/faceRecognize',
                element: <FaceRecognize />
            },
            {
                path: '/mainAdmin/MainAdminQuestions',
                element: <MainAdminQuestions />
            },
            {
                path: '/mainAdmin/MainAdminExams',
                element: <MainAdminExams />
            },
            {
                path: '/mainAdmin/MainAdminExamQuestions',
                element: <MainAdminExamQuestions />
            },
            {
                path: '/mainAdmin/MainAdminExamUser',
                element: <MainAdminExamUsers />
            },
            {
                path: '/mainAdmin/MainAdminUserQuestions',
                element: <MainAdminUserQuestions />
            },
              {
                path: '/mainAdmin/UserExam',
                element: <UserExam />
            },
             {
                path: '/mainAdmin/MainAdminUsersExam',
                element: <MainAdminUsersExam />
            }
            ,
    {
        path: "/mainAdmin/home",
        element: <Home />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }
        ]
    },     {
        path: "/",
        element: <Login />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    },
    {
        path: "/login/callback",
        element: <LoginCallback />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }
    , {
        path: "/chat",
        element: <Chat />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }, {
        path: "/chatMain",
        element: <ChatMain />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }, {
        path: "/chatDeepSeek",
        element: <ChatDeepSeek />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }, {
        path: "/chatRag",
        element: <ChatRag />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }, {
        path: "/chatCreateImage",
        element: <ChatCreateImage />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    },
    {
        path: '/GozineshLogin',
        element: <TripLogin />,
    },
    {
        path: '/gozinesh',
        element: <TripQuestions />,
    },
    {
        path: '/tripChat',
        element: <TripChat />,

    },
    {
        path: '/tripVoice',
        element: <TripVoice />,

    },
    {
        path: '/tripFirstStep',
        element: <TripFirstStep />,
    },
    {
        path: '/tripForm',
        element: <TripForm />,
    },


])